import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';

import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

import { KioskService } from '../kiosk.service';
import { KioskAppointment } from '../kiosk.model';
import { FetchKiosk, SetKioskUserHin, ResetKiosk } from '../kiosk.actions';
import { State as KioskState, isFetching } from '../kiosk.reducer';

import { AppInputComponent } from '../../shared/app-input/app-input.component';

import { Group } from '../../shared/models/group.model';

import { ValidateHin } from '../../shared/validators/hin.validator';

@Component({
  selector: 'kiosk-user-login',
  styles: [require('./kiosk-user-login.component.scss')],
  template: require('./kiosk-user-login.component.html'),
  preserveWhitespaces: false,
})
export class KioskUserLoginComponent implements OnInit, OnDestroy {
  @ViewChild(AppInputComponent, { read: ElementRef }) private appInputElement: ElementRef;

  public userLoginForm: FormGroup;

  private group: Group;
  private destroyed: Subject<boolean> = new Subject();

  constructor(
    @Inject('$state') private $state,
    private kioskService: KioskService,
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
  ) {
    this.createForm();
  };

  ngOnInit() {
    this.store.dispatch(new ResetKiosk());

    this.store.select((state: AppState): Group => state.group)
      .takeUntil(this.destroyed)
      .subscribe((group: Group): void => { this.group = group; });

    this.store.select(isFetching)
      .takeUntil(this.destroyed)
      .subscribe((fetchingStatus: boolean): void => {
        if (fetchingStatus) {
          this.$state.go('kiosk.informations');
        }
      });
  }

  ngOnDestroy() {
    this.destroyed.next(true);
  }

  updateHin(hin: string): void {
    this.userLoginForm.patchValue({ hin });
    this.setCaretPosition(this.appInputElement.nativeElement.querySelector('input'), hin.length)
  }

  submit(): void {
    if (!this.userLoginForm.valid) {
      return;
    }
    const hin: string = this.userLoginForm.controls.hin.value.replace(/\s/g, '');

    this.store.dispatch(new SetKioskUserHin(hin));
    this.store.dispatch(new FetchKiosk({ groupId: this.group.id, hin }));
  }

  private createForm(): void {
    this.userLoginForm = this.formBuilder.group({
      hin: ['', [Validators.required, ValidateHin]],
    });
  }

  private setCaretPosition(element, caretPos: number): boolean {
    element.value = element.value;

    if (element !== null) {
      if (element.createTextRange) {
          const range = element.createTextRange();
          range.move('character', caretPos);
          range.select();
          return true;
      } else {
        if (element.selectionStart || element.selectionStart === 0) {
          element.focus();
          setTimeout(() => element.setSelectionRange(caretPos, caretPos), 0);
          return true;
        }

        else  { 
          element.focus();
          return false;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk-user-login/kiosk-user-login.component.ts